export const style = {
	table: {
		width: "100vw",
		overflowX: "scroll",
	},
};
